import { taxActionTypes } from '@Actions/taxActions';

const TaxReducer = (state = { }, action) => {
  switch (action.type) {
  case taxActionTypes.CREATE_TAX.LOADING: {
    const { createTaxLoading } = action;
    return {
      ...state,
      createTaxLoading,
    };
  }
  case taxActionTypes.GET_TAXES.LOADING: {
    const { getTaxesLoading } = action;
    return {
      ...state,
      getTaxesLoading,
    };
  }
  case taxActionTypes.GET_TAXES.SUCCESS: {
    const { taxes, isTaxGroup } = action;
    if (isTaxGroup) {
      return {
        ...state,
        taxesGroup: taxes,
      };
    }
    return {
      ...state,
      taxes,
    };
  }
  case taxActionTypes.UPDATE_TAX.LOADING: {
    const { updateTaxLoading } = action;
    return {
      ...state,
      updateTaxLoading,
    };
  }
  case taxActionTypes.GET_TAX_TYPES.LOADING: {
    const { getTaxTypesLoading } = action;
    return {
      ...state,
      getTaxTypesLoading,
    };
  }
  case taxActionTypes.GET_TAX_TYPES.SUCCESS: {
    const { taxTypes } = action;
    return {
      ...state,
      taxTypes,
    };
  }
  default: {
    return state;
  }
  }
};

export default TaxReducer;
